import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { DroplistWidget } from '@eforall/dashboard';
import { VolunteeringAllVolunteersService } from '../volunteering-all-volunteers.service';
import { ApprovedVolunteersViewPart } from './approved-volunteers/approved-volunteers.part';
import { RemovedVolunteersViewPart } from './removed-volunteers/removed-volunteers.part';

@Component({
	selector: 'volunteering-all-volunteers-views-part',
	standalone: true,
	imports: [
		ApprovedVolunteersViewPart,
		RemovedVolunteersViewPart,
		DroplistWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './volunteering-all-volunteers-views.part.html',
})

export class VolunteeringAllVolunteersViewsPart implements OnInit {

	public service = inject(VolunteeringAllVolunteersService);

	ngOnInit() {
		this.service.initializeUrl();
	}
}